/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__Answer_0Inputs */

const en_help_center__getting_started__answer_0 = /** @type {(inputs: Help_Center__Getting_Started__Answer_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BidBattles is a capped-player auction platform where you compete against a limited number of participants to win premium products like vehicles, electronics, and experiences at potentially massive discounts. Unlike traditional auctions, each battle has a maximum number of seats, creating fair competition and exciting strategic gameplay.`)
};

/**
* | output |
* | --- |
* | "BidBattles is a capped-player auction platform where you compete against a limited number of participants to win premium products like vehicles, electronics,..." |
*
* @param {Help_Center__Getting_Started__Answer_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__answer_0 = /** @type {((inputs?: Help_Center__Getting_Started__Answer_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__Answer_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__getting_started__answer_0(inputs)
});